<template>
  <div>

    <div class="row">
      <div class="col-6">
        <div class="m-portlet">

          <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
              <div class="m-portlet__head-title">
                <h3 class="m-portlet__head-text">
                  Invoices
                </h3>
              </div>
            </div>
          </div>

          <div class="m-portlet__body">

            <div class="row mt-5">
              <div class="col-12">

                <table class="table table-stripped">
                  <tr>
                    <th>id</th>
                    <th>batch</th>
                    <th>client</th>
                    <th>period</th>
                    <th>confirmed</th>
                    <th>sent</th>
                    <th>due</th>
                    <th>due in (days)</th>
                    <th>paid</th>
                    <th>payment late (days)</th>
                  </tr>
                  <tr v-for="invoice in invoices" :class="{'invoice-warning' : invoice.due_days && invoice.due_days < 1}">
                    <td>{{ invoice.id }}</td>
                    <td>{{ invoice.batch }}</td>
                    <td>{{ invoice.client.name }}</td>
                    <td>{{ invoice.period }}</td>
                    <td>{{ invoice.confirmed ? 'Yes' : 'No' }}</td>
                    <td>{{ invoice.sent ? 'Yes' : 'No' }}</td>
                    <td>{{ invoice.due }}</td>
                    <td>{{ invoice.due_days || '-' }}</td>
                    <td>
                      <div class="btn btn-xs" :class="{'btn-default' : !invoice.paid, 'btn-success' : invoice.paid}" @click="togglePaid(invoice)">
                        <span v-if="!invoice.paid"><i class="fas fa-minus"></i></span>
                        <span v-if="invoice.paid"><i class="fas fa-check"></i></span>
                      </div>
                    </td>
                    <td>{{ invoice.paid_late_days || '-' }}</td>
                  </tr>
                </table>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6">

        <div class="m-portlet">

          <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
              <div class="m-portlet__head-title">
                <h3 class="m-portlet__head-text">
                  Stats
                </h3>
              </div>
            </div>
          </div>

          <div class="m-portlet__body">

            <div class="row" v-if="stats">
              <div class="col">

                <div>Total invoices sent: {{ stats.total_sent }}</div>
                <div>Total invoice paid: {{ stats.total_paid }}</div>
                <div>Invoices that paid late: {{ stats.paid_late }}</div>

              </div>
            </div>

            <div class="row mt-5">
              <div class="col">
                <table class="table table-stripped">
                  <tr>
                    <th>Client</th>
                    <th>Invoices sent</th>
                    <th>Invoices paid</th>
                    <th>Invoices paid late</th>
                  </tr>
                  <tr v-for="client in clients">
                    <td>{{ client.name }}</td>
                    <td>{{ client.stats.total_sent }}</td>
                    <td>{{ client.stats.total_paid }}</td>
                    <td>{{ client.stats.paid_late }}</td>
                  </tr>
                </table>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  export default {
    created() {
      this.load()
    },
    data() {
      return {
        invoices: null,
        stats: null,
        clients: null,
      }
    },
    methods: {
      load() {
        this.axios.get('invoices').then(response => {
          this.invoices = response.data.data
        })
        this.loadClients()
        this.loadStats()
      },
      loadClients() {
        this.axios.get('invoices/client-stats').then(response => {
          this.clients = response.data.data
        })
      },
      loadStats() {
        this.axios.get('invoices/stats').then(response => {
          this.stats = response.data.data
        })
      },
      togglePaid(invoice) {
        this.axios.post('invoices/' + invoice.id + '/toggle-paid').then(response => {
          let newInvoice = response.data.data

          let index = _.findIndex(this.invoices, i => {
            return i.id === invoice.id
          })

          this.invoices[index] = newInvoice
          this.$forceUpdate()

          this.loadStats()
          this.loadClients()

        }).catch(err => {
          //
        })
      }
    }

  }
</script>
<style lang="scss">
  .invoice-warning {
    background: #ffb82254;
  }
</style>



// WEBPACK FOOTER //
// src/views/invoices/Index.vue